import { PAGE_INFO_FIELDS } from "@/graphql/pagination";
import { CONSUMER_ORDER_FIELDS, ORDER_LIST_FIELDS, SOURCE_BASKET_FIELDS } from "@/graphql/shop";
import { gql } from "@apollo/client";

export const ORDER_QUERY = gql`
  query GetOrder($id: ID!, $userId: ID!) {
    order(id: $id, userId: $userId) {
      ...ConsumerOrderFields
      sourceBasket {
        ...SourceBasketFields
      }
    }
  }
  ${CONSUMER_ORDER_FIELDS}
  ${SOURCE_BASKET_FIELDS}
`;

export const ORDER_HISTORY_PAGE_QUERY = gql`
  query OrderHistoryPageQuery($page: Int, $orderBy: String, $search: String, $userId: ID!) {
    ordersPagination(page: $page, orderBy: $orderBy, search: $search, userId: $userId) {
      items {
        ...OrderListFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${ORDER_LIST_FIELDS}
  ${PAGE_INFO_FIELDS}
`;
